/**
 * 전역 모드 토글 (DESIGN §3.1 · §7.3).
 *
 * 모드를 바꾸면 화면의 **모든 숫자가 갱신된다.** 실측에서 같은 데이터가
 * strict 99.8% / standard 99.0% / user_facing 18.3% 로 갈렸다 — 이 토글은
 * 편의 기능이 아니라 "단일 고장률은 없다"는 사실의 인터페이스다.
 *
 * `agg_daily` 가 모드 3종을 사전 계산하므로 응답은 1초 미만이다 (§7.3).
 */

import { MODE_HINT, MODE_LABEL, MODES, type Mode } from '@/lib/types'
import { useFilters } from '@/stores/filters'
import './ModeToggle.css'

export function ModeToggle() {
  const mode = useFilters((s) => s.mode)
  const setMode = useFilters((s) => s.setMode)

  return (
    <div className="modetoggle">
      <span className="modetoggle__label" id="mode-toggle-label">
        고장 정의
      </span>
      <div className="modetoggle__group" role="radiogroup" aria-labelledby="mode-toggle-label">
        {MODES.map((m: Mode) => (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={mode === m}
            className={`modetoggle__btn${mode === m ? ' is-active' : ''}`}
            title={MODE_HINT[m]}
            onClick={() => setMode(m)}
          >
            {MODE_LABEL[m]}
          </button>
        ))}
      </div>
      <p className="modetoggle__hint">{MODE_HINT[mode]}</p>
    </div>
  )
}
